"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAgreementList = void 0;
const Base_1 = require("./Base");
exports.GetAgreementList = {
    url: Base_1.URL_BASE + "/GetAgreementList",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetAgreementList.js.map